export const normalizeTelegramWebLink = (link) => {
  if (!link) return '';

  if (link.startsWith('tg://proxy?')) {
    return link.replace('tg://proxy?', 'https://t.me/proxy?');
  }

  if (link.startsWith('tg://socks?')) {
    return link.replace('tg://socks?', 'https://t.me/socks?');
  }

  if (link.startsWith('tg://resolve?')) {
    const params = new URLSearchParams(link.slice('tg://resolve?'.length));
    const domain = params.get('domain');
    if (!domain) return '';
    params.delete('domain');
    const query = params.toString();
    return `https://t.me/${domain}${query ? `?${query}` : ''}`;
  }

  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(link) ? link : `https://${link}`;
};

export const buildTelegramAppLink = (link) => {
  if (!link) return '';
  if (link.startsWith('tg://') || link.startsWith('telegram://')) return link;

  try {
    const webLink = normalizeTelegramWebLink(link);
    const parsedUrl = new URL(webLink);
    const path = parsedUrl.pathname.replace(/^\/+/, '');
    const params = parsedUrl.searchParams.toString();

    if (path.startsWith('proxy')) {
      return `tg://proxy${params ? `?${params}` : ''}`;
    }

    if (path.startsWith('socks')) {
      return `tg://socks${params ? `?${params}` : ''}`;
    }

    const username = path.split('/')[0];
    if (!username) return webLink;

    const resolveParams = new URLSearchParams(parsedUrl.searchParams);
    resolveParams.set('domain', username);
    return `tg://resolve?${resolveParams.toString()}`;
  } catch {
    return link;
  }
};

export const openTelegramAppLink = (link, options = {}) => {
  const appLink = buildTelegramAppLink(link);
  const webLink = normalizeTelegramWebLink(link);
  const { webFallback = true } = options;

  if (!appLink) return;

  window.location.href = appLink;

  if (!webFallback || !webLink || webLink === appLink) {
    return;
  }

  const fallbackTimer = setTimeout(() => {
    if (document.visibilityState === 'visible') {
      window.location.href = webLink;
    }
  }, 1400);

  const clearFallback = () => {
    clearTimeout(fallbackTimer);
    window.removeEventListener('blur', clearFallback);
    window.removeEventListener('pagehide', clearFallback);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
  };

  const handleVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      clearFallback();
    }
  };

  window.addEventListener('blur', clearFallback, { once: true });
  window.addEventListener('pagehide', clearFallback, { once: true });
  document.addEventListener('visibilitychange', handleVisibilityChange);
};

export const handleTelegramLinkClick = (event, link) => {
  event.preventDefault();
  openTelegramAppLink(link);
};
